module.exports = __webpack_public_path__ + "static/media/videos-sample.12933719.svg";